import { is_on_mobile } from "../app";
import "./slider.css";
import { Prog } from "../utils/Prog";
// import "./PageShowMovie.css";

export class SliderBuilder {
  constructor(iParam) {
    this.is_dragging = false;
    this.timeout_calcul = 0;
    this.indice = iParam && iParam.indice ? iParam.indice : 0;
    this.scrollOffset = 0;
    this.$parent = null;
    this.events = [];
    this.chain_events = [];
    this.website_config = iParam && iParam.website_config ? iParam.website_config : {"type" : "site"};
  }

  $create(iParam) {
    // console.log("SliderBuilder - $create - this.website_config", iParam, this.website_config);
    this.m_prog = new Prog();

    if(this.website_config.type == "site"){
      try {
        this.events = JSON.parse(localStorage.getItem("events"));
      } catch (err) {
        this.events = [];
      }
    }else if(this.website_config.type == "chain"){
      try {
        this.chain_events = localStorage.getItem("chain_events") ? JSON.parse(localStorage.getItem("chain_events")) : [];
      } catch (err) {
        this.chain_events = [];
      }
    }

    this.$slider_container = $("<div>").addClass("slider_container d-flex justify-content-center position-relative");

    this.$parent = iParam && iParam.$parent ? iParam.$parent : this.$slider_container;

    if(iParam){
      if(iParam.id){
        this.$slider_container.attr({"id":iParam.id});
      }
    }
    
    return this.$slider_container;
  }

  $createSlider() {
    const self = this;
    const cardSlider = this.slider;

    const sliderElement = cardSlider.get(0);

    // Gestion du scroll au DRAG de la souris
    let isMouseDown = false;
    let startX;
    let scrollLeft;

    sliderElement.addEventListener("mousedown", (event) => {
      event.preventDefault();
      isMouseDown = true;
      startX = event.pageX;
      scrollLeft = sliderElement.scrollLeft;
      self.is_dragging = false;
    });
    sliderElement.addEventListener('mouseleave', () => {
      isMouseDown = false;
    });
    sliderElement.addEventListener("mouseup", () => {
      isMouseDown = false;
    });
    sliderElement.addEventListener("mousemove", (event) => {
      if (!isMouseDown) {
        return;
      }
      event.preventDefault();
      const x = event.pageX - sliderElement.offsetLeft;
      const walk = (x - startX) * 1;
      sliderElement.scrollLeft = scrollLeft - walk;
      if(walk < -25 || walk > 25){
        self.is_dragging = true;
      }
    });

    cardSlider.on("scroll",(e) => {
      const $elem = $(e.currentTarget);
      const slider_width = $elem[0].scrollWidth;

      // console.log($elem[0].scrollLeft)
      // console.log(slider_width - ($elem.outerWidth() + $elem.scrollLeft()) )

      if($elem[0].scrollLeft == 0){
        // console.log("butée gauche")
        this.leftArrow.addClass("hide");
      }else if($elem[0].scrollLeft > 0 && (slider_width - ($elem.outerWidth() + $elem.scrollLeft()) > 1)){
        // console.log("pas en butée")
        this.leftArrow.removeClass("hide");
        this.rightArrow.removeClass("hide");
      }else if($elem[0].scrollLeft > 0){
        // console.log("butée droite")
        this.rightArrow.addClass("hide");
      }
    })

    if(!is_on_mobile()){
      this.leftArrow.on("click", function () {
        let scroll_value = self.scrollOffset != 0 ? self.scrollOffset : 180;
        sliderElement.scrollBy({
          left: -(scroll_value * 2),
          behavior: "smooth",
        });
      });

      this.rightArrow.on("click", function () {
        let scroll_value = self.scrollOffset != 0 ? self.scrollOffset : 180;
        // sliderElement.scrollBy({
        self.slider[0].scrollBy({
          left: scroll_value * 2,
          behavior: "smooth",
        });
      });
    }

    // Si la largeur de "Content" est infèrieur à la largeur de "Slider" moins la largeur des flèches
    // On masque les flèches
    setTimeout(() => {
        if(this.slider[0].scrollWidth < (this.$slider_container[0].scrollWidth - (this.leftArrow[0].clientWidth + this.rightArrow[0].clientWidth))){
            this.leftArrow.remove();
            this.rightArrow.remove();
        }
    }, this.timeout_calcul);  
  }

  $createEventsCards(events) {
    if (!events) {
      const events = this.events;
    }
    const self = this;

    this.leftArrow = $("<div>").addClass("movie-slider-arrow movies-sliders-arrow-left d-flex flex-column hide").appendTo(this.$slider_container);
      var $div=$("<div/>").addClass("top").appendTo(this.leftArrow);
      var $div=$("<div/>").addClass("bottom").appendTo(this.leftArrow);

    this.slider = $("<div>").addClass(is_on_mobile() ? "mobile-slider" : "slider").appendTo(this.$slider_container);
    
    let event_index = 0;
    events.forEach((event) => {
      var poster_url = event.bill_url ? event.bill_url : "https://static.monnaie-services.com/www-img/ticketingcine/no_poster_imsweb.webp";
      event.certification = this.m_prog.ParseCertification(event.certification_id);
      if(poster_url){
        if(is_on_mobile()){
          // poster_url = poster_url.replace("/120","/240");
        }else{
            poster_url = poster_url.replace("/120","/240");
        }
      }

      const $cardSlider = $("<div/>").addClass(is_on_mobile() ? "mobile-slider-card" : "slider-card").addClass("d-flex flex-column pointer").attr("movie_id", event.id).appendTo(this.slider).css({
          "animation-delay": (event_index/6)+"s"
      }).on("click", function () {
        // const movieId = $(this).attr("movie_id");
        if(!self.is_dragging){
          window.location.href = `#showmovie?id=${event.id}`;
          // location.reload();
        }
      });

        var $poster_container=$("<div/>").addClass("poster_container m-auto").appendTo($cardSlider);
          var $poster=$("<img/>").addClass("poster").attr({"src":poster_url, "alt":event.title, "loading":"lazy"}).appendTo($poster_container);
          var $poster_header=$("<div/>").addClass("poster_header d-flex").appendTo($poster_container);
          if(event.certification && event.certification.img){
              var $img_certification=$("<img/>").addClass("img_certification my-auto").attr({"src":event.certification.img, "alt":"", "loading":"lazy"}).appendTo($poster_header);
          }
          if(event.custom_tags){
            event.custom_tags.forEach(tag_id => {
              const data_tag = gl_custom_prog_tags[tag_id];
              if(!data_tag){
                  return;
              }
              var $img=$("<img/>").addClass("custom_tag my-auto").attr({"src":"https://images.imscine.com/prog_tag/x75/"+gl_config.site_id+"/"+tag_id+".png?time="+moment().unix(), "title":_l(data_tag.description) , "alt":data_tag.name, "loading":"lazy"}).appendTo($poster_header);
            });
          }

          // ===== Titre du film =====
          var $title=$("<div/>").addClass("title mx-auto pt-2 flex-grow-1").text(event.title).appendTo($cardSlider).css({
              "max-width" : $poster[0].clientWidth
          });

      event_index ++;

      self.scrollOffset = $poster_container.width();
    });

    this.rightArrow = $("<div>").addClass("movie-slider-arrow movies-sliders-arrow-right d-flex flex-column").appendTo(this.$slider_container);
      var $div=$("<div/>").addClass("top").appendTo(this.rightArrow);
      var $div=$("<div/>").addClass("bottom").appendTo(this.rightArrow);

    this.$createSlider();
  }

  $createSessionCards(iData) {
    // console.log("$createSessionCards", iData)
    if(!iData || iData.length<=0){
      return;
    }
    moment.locale('fr');
    const self = this;
    var dh_now = moment().format("YYYYMMDDHHmm");
    var moment_now = moment(dh_now, "YYYYMMDD HH:mm");
    const sell_time_before_session = gl_ems_config.data_cinema ? gl_ems_config.data_cinema.sell_time_before_session : 0;

    this.leftArrow = $("<div>").addClass("movie-slider-arrow movies-sliders-arrow-left d-flex flex-column hide").appendTo(this.$slider_container);
      var $div=$("<div/>").addClass("top").appendTo(this.leftArrow);
      var $div=$("<div/>").addClass("bottom").appendTo(this.leftArrow);

    this.slider = $("<div>").addClass(is_on_mobile() ? "mobile-slider" : "slider").appendTo(this.$slider_container);

    let card_index = 0;
    iData.forEach(data => {
      const is_session = data.data_movie ? true : false;
      const is_superbillet = data.data_movie ? false : true;

      const event = data.data_movie ? data.data_movie : data; // Seance ou Superbillet
      var poster_url = event.bill_url ? event.bill_url : "https://static.monnaie-services.com/www-img/ticketingcine/no_poster_imsweb.webp";
      // if(poster_url.indexOf("movies.monnaie-services.com/images")>0){
      //   poster_url = "https://static.monnaie-services.com/www-img/ticketingcine/no_poster_imsweb.webp";
      // }
      event.certification = this.m_prog.ParseCertification(event.certification_id);
      if(poster_url){
        if(is_on_mobile()){
          poster_url = poster_url.replace("/120","/240");
        }else{
            poster_url = poster_url.replace("/120","/240");
        }
      }

      const $cardSlider = $("<div/>").addClass(is_on_mobile() ? "mobile-slider-card" : "slider-card").addClass("d-flex flex-column pointer").attr("movie_id", event.id).appendTo(this.slider).css({
          "animation-delay": (card_index/6)+"s"
      }).on("click", function () {
        if(!self.is_dragging){
          if(is_session){
            window.location.href = `#showsession?id=${data.id}`;
          }else if(is_superbillet){
            if(gl_config.type == "site"){
              window.location.href = `#showsuperbillet?id=${data.id}`;
            }else if(gl_config.type == "chain"){
              let site_config = gl_config.chain.sites.filter(site => site.id == data.site_id)[0];
              let href = site_config && site_config.website_full_url ? site_config.website_full_url : "https://www.ticketingcine.com/?"+data.site_id;
              href += "#showsuperbillet?id="+data.id;
              window.open(href,"_blank");
            }
          }
        }
      });

        var $poster_container=$("<div/>").addClass("poster_container mx-auto").appendTo($cardSlider);
          var $poster=$("<img/>").addClass("poster").attr({"src":poster_url, "alt":event.title, "loading":"lazy"}).appendTo($poster_container);
          var $poster_header=$("<div/>").addClass("poster_header d-flex").appendTo($poster_container);
          if(event.certification && event.certification.img){
              var $img_certification=$("<img/>").addClass("img_certification my-auto").attr({"src":event.certification.img, "alt":"", "loading":"lazy"}).appendTo($poster_header);
          }
          if(event.custom_tags){
            event.custom_tags.forEach(tag_id => {
              const data_tag = gl_custom_prog_tags[tag_id];
              if(!data_tag){
                  return;
              }
              var $img=$("<img/>").addClass("custom_tag my-auto").attr({"src":"https://images.imscine.com/prog_tag/x75/"+gl_config.site_id+"/"+tag_id+".png?time="+moment().unix(), "title":_l(data_tag.description) , "alt":data_tag.name, "loading":"lazy"}).appendTo($poster_header);
            });
          }

          // ===== Titre du film =====
          var $title=$("<div/>").addClass("title mx-auto pt-2").text(event.title).appendTo($cardSlider).css({
              "max-width" : $poster[0].clientWidth
          });

          if(is_session){
            var m_dh_session = moment(data.date, "YYYYMMDD HH:mm");
            let time_before_start_session = m_dh_session.diff(moment_now, "minutes");

            if(sell_time_before_session >= time_before_start_session){
                $poster.removeClass("pointer");
                $cardSlider.removeClass("pointer").off("click");
                if(event.certification && event.certification.img){
                    $img_certification.remove();
                }
                var $text=$("<div/>").addClass("text_headline my-auto p-1").text("Réservation en ligne terminée").appendTo($poster_header);
                var $disabled=$("<div/>").addClass("position-absolute top-0 w-100 h-100 disabled radius-5").appendTo($poster_container).css({
                    "max-width" : $poster[0].clientWidth
                });
            }else if(data.headline && data.headline!=""){
                $text=$("<div/>").addClass("text_headline my-auto p-1").text(data.headline).appendTo($poster_header);
            }

            var $session_date=$("<div/>").addClass("session_date mx-auto pt-0 pt-md-3 text-capitalize").text(moment(data.date.substring(0,8)).format("ddd DD MMM")).appendTo($cardSlider).css({
                "max-width" : $poster[0].clientWidth
            });

            var $session_hour=$("<div/>").addClass("session_hour mx-auto").text((data.date).substr(8,2)+"h"+(data.date).substr(10,2)).appendTo($cardSlider).css({
                "max-width" : $poster[0].clientWidth
            });

            if(event.art_et_essai_actif){
              if(!data.features){
                  data.features = [];
              }
              if(data.features.indexOf("art_et_essai")<=0){
                  data.features.push("art_et_essai");
              }
            }

            if(data.features && data.features.length>0){
              var $features_container=$("<div/>").addClass("d-flex flex-wrap features_container").appendTo($cardSlider).css({
                  "max-width" : $poster[0].clientWidth
              });

              data.features.forEach(feature => {
                  if(feature == "headline"){
                      return;
                  }
                  let feature_url = "https://static.monnaie-services.com/www-img/session/features/"+feature+".png";
                  switch(feature){
                      default:
                          var $img=$("<img/>").addClass("mx-auto mt-auto features").attr({"src":feature_url, "title":_l('#session_feature_'+feature) , "alt":feature, "loading":"lazy"}).appendTo($features_container);
                          break;
                  }
              })
            }

            if(data.custom_tags){
              // var $session_custom_tags_container=$("<div/>").addClass("session_custom_tags_container").appendTo($session);
              data.custom_tags.forEach(tag_id => {
                  const data_tag = gl_custom_prog_tags[tag_id];
                  if(!data_tag){
                      return;
                  }
                  var $img=$("<img/>").addClass("custom_tag my-auto").attr({"src":"https://images.imscine.com/prog_tag/x75/"+gl_config.site_id+"/"+tag_id+".png?time="+moment().unix(), "title":_l(data_tag.description) , "alt":data_tag.name, "loading":"lazy"}).appendTo($poster_header);
              });
            }
          }else if(is_superbillet){
            var m_dh_session = moment(data.end_date, "YYYYMMDD HH:mm");
            let time_before_start_session = m_dh_session.diff(moment_now, "minutes");

            if(sell_time_before_session >= time_before_start_session){
                $poster.removeClass("pointer");
                $cardSlider.removeClass("pointer").off("click");
                var $text=$("<div/>").addClass("text_headline my-auto p-1").text(_l("Réservation en ligne terminée")).appendTo($poster_header);
                var $disabled=$("<div/>").addClass("position-absolute top-0 w-100 h-100 disabled radius-5").appendTo($poster_container).css({
                    "max-width" : $poster[0].clientWidth
                });
            } 
          }
      
      card_index ++;

      self.scrollOffset = $poster_container.width();
    });

    this.rightArrow = $("<div>").addClass("movie-slider-arrow movies-sliders-arrow-right d-flex flex-column").appendTo(this.$slider_container);
      var $div=$("<div/>").addClass("top").appendTo(this.rightArrow);
      var $div=$("<div/>").addClass("bottom").appendTo(this.rightArrow);
    this.$createSlider();
  }

  $createSuperbilletCards(iSuperbillets) {
    // console.log("$createSuperbilletCards", iSuperbillets)
    if(!iSuperbillets || iSuperbillets.length<=0){
      return;
    }
    moment.locale('fr');
    const self = this;
    var dh_now = moment().format("YYYYMMDDHHmm");
    var moment_now = moment(dh_now, "YYYYMMDD HH:mm");
    const sell_time_before_session = gl_ems_config.data_cinema.sell_time_before_session;

    this.leftArrow = $("<div>").addClass("movie-slider-arrow movies-sliders-arrow-left d-flex flex-column hide").appendTo(this.$slider_container);
      var $div=$("<div/>").addClass("top").appendTo(this.leftArrow);
      var $div=$("<div/>").addClass("bottom").appendTo(this.leftArrow);

    this.slider = $("<div>").addClass(is_on_mobile() ? "mobile-slider" : "slider").appendTo(this.$slider_container);

    let card_index = 0;
    iSuperbillets.forEach(superbillet => {
      // console.log(superbillet)
      if(!superbillet.visible){
        return;
      }
      var poster_url = superbillet.bill_url ? superbillet.bill_url : "https://static.monnaie-services.com/www-img/ticketingcine/no_poster_imsweb.webp";
      if(poster_url){
        if(is_on_mobile()){
          poster_url = poster_url.replace("/120","/240");
        }else{
          poster_url = poster_url.replace("/120","/240");
        }
      }

      const $cardSlider = $("<div/>").addClass(is_on_mobile() ? "mobile-slider-card" : "slider-card").addClass("d-flex flex-column pointer").attr("movie_id", superbillet.id).appendTo(this.slider).css({
          "animation-delay": (card_index/6)+"s"
      }).on("click", function () {
        if(!self.is_dragging){
          window.location.href = `#showsuperbillet?id=${superbillet.id}`;
          // location.reload();
        }
      });

        var $poster_container=$("<div/>").addClass("poster_container m-auto").appendTo($cardSlider);
          var $poster=$("<img/>").addClass("poster").attr({"src":poster_url, "alt":superbillet.title, "loading":"lazy"}).appendTo($poster_container);
          var $poster_header=$("<div/>").addClass("poster_header d-flex").appendTo($poster_container);

          // ===== Titre du film =====
          var $title=$("<div/>").addClass("title mt-auto mx-auto pt-2").text(superbillet.title).appendTo($cardSlider).css({
              "max-width" : $poster[0].clientWidth
          });

          var m_dh_session = moment(superbillet.end_date, "YYYYMMDD HH:mm");
          let time_before_start_session = m_dh_session.diff(moment_now, "minutes");

          if(sell_time_before_session >= time_before_start_session){
              $poster.removeClass("pointer");
              $cardSlider.removeClass("pointer").off("click");
              var $text=$("<div/>").addClass("text_headline my-auto p-1").text(_l("Réservation en ligne terminée")).appendTo($poster_header);
              var $disabled=$("<div/>").addClass("position-absolute top-0 w-100 h-100 disabled radius-5").appendTo($poster_container).css({
                  "max-width" : $poster[0].clientWidth
              });
          }      
      card_index ++;

      self.scrollOffset = $poster_container.width();
    });

    this.rightArrow = $("<div>").addClass("movie-slider-arrow movies-sliders-arrow-right d-flex flex-column").appendTo(this.$slider_container);
      var $div=$("<div/>").addClass("top").appendTo(this.rightArrow);
      var $div=$("<div/>").addClass("bottom").appendTo(this.rightArrow);
    this.$createSlider();

    if(card_index == 0){
      $("#wrap_superbillet").remove();
    }
  }

  $createConfiserieCards(iConfiseries, iMode) {
    // console.log("$createConfiserieCards", iConfiseries,iMode)
    if(!iConfiseries || iConfiseries.length<=0){
      return;
    }
    moment.locale('fr');
    const self = this;

    this.leftArrow = $("<div>").addClass("movie-slider-arrow movies-sliders-arrow-left d-flex flex-column hide").appendTo(this.$slider_container);
      var $div=$("<div/>").addClass("top").appendTo(this.leftArrow);
      var $div=$("<div/>").addClass("bottom").appendTo(this.leftArrow);

    this.slider = $("<div>").addClass(is_on_mobile() ? "mobile-slider" : "slider").appendTo(this.$slider_container);

    let card_index = 0;
    iConfiseries.forEach(confiserie => {
      const $cardSlider = $("<div/>").addClass(is_on_mobile() ? "mobile-slider-card" : "slider-card").addClass("d-flex flex-column position-relative align-items-stretch card_item_confiserie").attr("item_id", confiserie.id).appendTo(this.slider).css({
        "animation-delay": (card_index/6)+"s"
      });       
        var $wrap=$("<div/>").addClass("wrap position-relative").appendTo($cardSlider);
          var $qty=$("<div/>").addClass("qty nb_item nb_item_"+confiserie.item_type+"_id_"+confiserie.id).appendTo($wrap);
          var $poster_container=$("<div/>").addClass("poster_container m-auto").appendTo($wrap);
            var $poster=$("<img/>").addClass("poster").attr({"src":confiserie.img, "alt":confiserie.label, "loading":"lazy"}).appendTo($poster_container);

        if(!confiserie.sold_out){
          if(confiserie.total_price){
              var price=gl_app.arrondi({
                  "montant":(confiserie.total_price)
              });
              let text_price = currency_format(gl_ems_config.data_cinema.devise,price,2);
              let tab_text_price = text_price.split(".");
              var $container_price=$("<div/>").addClass("container_price d-flex").appendTo($wrap);
                  var $text=$("<div/>").addClass("text my-auto").text(tab_text_price[0]).appendTo($container_price);
                  var $text=$("<div/>").addClass("text decimal").text(","+tab_text_price[1]).appendTo($container_price);
          };
          $cardSlider.addClass("pointer");
          if(iMode == "compose_menu"){
            $cardSlider.addClass("menu_product_"+this.indice);
            $cardSlider.data({"indice":this.indice});
            this.timeout_calcul = 250;
          }
          
          $cardSlider.on("click", function () {
          if(!self.is_dragging){
            if(iMode == "confiserie"){
              gl_app.EMSConfiserie.select_item({
                  "data_item":confiserie,
                  "elem_from" : $(this)
              });
            }else if(iMode == "compose_menu"){
              gl_app.EMSConfiserie.select_item_in_menu({
                  "data_item":confiserie,
                  "elem_from" : $(this)
              });
            }
          }
        }); 
        }else{
          $cardSlider.addClass("sold_out");
          var $disabled=$("<div/>").addClass("position-absolute top-0 start-0 w-100 h-100 disabled radius-5").appendTo($cardSlider);
          var $div_phrase_soldout=$("<div/>").addClass("ct_phrase_soldout d-flex").appendTo($cardSlider)
              var $phrase_soldout=$("<div/>").addClass("phrase_soldout my-auto p-1").text(_l("Epuisé")).appendTo($div_phrase_soldout);
        }

        var $label=$("<div/>").addClass("label text-center mb-2").text(confiserie.label).appendTo($cardSlider);

      card_index ++;

      self.scrollOffset = $poster_container.width();
    });

    this.rightArrow = $("<div>").addClass("movie-slider-arrow movies-sliders-arrow-right d-flex flex-column").appendTo(this.$slider_container);
      var $div=$("<div/>").addClass("top").appendTo(this.rightArrow);
      var $div=$("<div/>").addClass("bottom").appendTo(this.rightArrow);
    this.$createSlider();

    if(card_index == 0){
      // $("#wrap_superbillet").remove();
    }
  }

  $createCustomCards(iParam) {
    // console.log("$createCustomCards", iParam)
    const iData = iParam.data;
    const $parent = iParam.$parent;
    if(!iData || iData.length<=0){
      return;
    }

    const self = this;
    let card_index = 0;
    let has_media_valid = false;
    let today = moment().format("YYYY-MM-DD");

    this.leftArrow = $("<div>").addClass("movie-slider-arrow movies-sliders-arrow-left d-flex flex-column hide").appendTo(this.$slider_container);
      var $div=$("<div/>").addClass("top").appendTo(this.leftArrow);
      var $div=$("<div/>").addClass("bottom").appendTo(this.leftArrow);

    this.slider = $("<div>").addClass(is_on_mobile() ? "mobile-slider" : "slider").addClass("slider-media-custom").appendTo(this.$slider_container);

    this.rightArrow = $("<div>").addClass("movie-slider-arrow movies-sliders-arrow-right d-flex flex-column").appendTo(this.$slider_container);
      var $div=$("<div/>").addClass("top").appendTo(this.rightArrow);
      var $div=$("<div/>").addClass("bottom").appendTo(this.rightArrow);
    

    // On remplit le slider avec les médias
    iData.forEach(media => {
      // console.log(media)

      // Gestion des dates de validité d'affichage du media
      if(media.validity && media.validity.type == "date"){
        var from = media.validity.from;
        var to = media.validity.to;
        if(from > today || to < today){
          return;
        }
      }

      has_media_valid = true;

      const $cardSlider = $("<div/>").addClass(is_on_mobile() ? "mobile-slider-card" : "slider-card").addClass("d-flex flex-column pointer").attr({"id":"media_id_"+media.id}).appendTo(this.slider).css({
          "animation-delay": (card_index/6)+"s"
      });
        var $poster_container=$("<div/>").addClass("poster_container m-auto").appendTo($cardSlider);
          if(media.type == "image"){
              media.media_url = media.media_url.replace("/120x","/600x");
              media.media_url = media.media_url.replace("/320","/600");
              var $img=$("<img/>").addClass("poster").attr({"src":media.media_url, "alt":"", "loading":"lazy"}).appendTo($poster_container);
          }
          if(media.type == "video" || media.description){
              var $flexbox=$("<div/>").addClass("box_details").appendTo($poster_container);
              if(media.type == "video"){
                  media.media_url = media.media_url.replace("/ld","/hd");
                  media.thumbnail_url = media.thumbnail_url.replace("/120x","/600x");
                  media.thumbnail_url = media.thumbnail_url.replace("/320","/600");
                  var $img=$("<img/>").addClass("poster").attr({"src":media.thumbnail_url, "alt":"", "loading":"lazy"}).appendTo($poster_container);
                  var $icon=$("<img/>").addClass("icon icon_svg player_icon").attr({"src":"https://static.monnaie-services.com/fontawesome/svgs/regular/circle-play.svg", "alt":"", "loading":"lazy"}).appendTo($flexbox).on("click",(e) => {
                      e.preventDefault();
                      e.stopPropagation();
                      this.m_prog.player_trailer(media.media_url)
                  });
              }
              if(media.description){
                  var $description=$("<div/>").addClass("description_img m-auto").text(media.description).appendTo($flexbox);
              }
          }

      // Gestion du click du media
      $img.on("click", function (e) {
        e.preventDefault()
        if(!self.is_dragging){
          iParam.class_from.set_media_action(media);
        }
      });

      card_index ++;

      self.scrollOffset = $poster_container.width();
    });

    this.$createSlider();

    if(!has_media_valid){
      $parent.remove();
    }
  }

  $filterCurrentWeekMovies(iParam) {
    // console.log("$filterCurrentWeekMovies", iParam)
    moment.locale(gl_config.site ? gl_config.site.lang : "fr")
    const currentDate = moment();
    let next_week_start = moment(); 
    let nb_day_to_next_week_start = 0;
    switch(currentDate.isoWeekday()){
      case 1:
        nb_day_to_next_week_start = 1;
        break;
      case 2:
        nb_day_to_next_week_start = 0;
        break;
      case 3:
        nb_day_to_next_week_start = 6;
        break;
      case 4:
        nb_day_to_next_week_start = 5;
        break;
      case 5:
        nb_day_to_next_week_start = 4;
        break;
      case 6:
        nb_day_to_next_week_start = 3;
        break;
      case 7:
        nb_day_to_next_week_start = 2;
        break;
      default:
        break;
    }
    let events = iParam && iParam.events ? iParam.events : [];
    let num_cine = iParam && iParam.num_cine ? iParam.num_cine : null;

    next_week_start.add(nb_day_to_next_week_start, 'days')

    var filteredEvents = [];

    if(gl_config.type == "site"){
      filteredEvents = this.events.filter((event) => {
        const validSessions = event.sessions.filter((session) => {
          const eventDate = moment(session.date, "YYYYMMDDHHmm").format("YYYYMMDD");
          return ((eventDate <= moment(next_week_start).format("YYYYMMDD")) && (currentDate.diff(moment(session.date, "YYYYMMDDHHmm"),"m") < 0));
        });
        return validSessions.length > 0;
      });
    }else if(gl_config.type == "chain"){
      filteredEvents = this.chain_events.filter((chain_event) => {
        if(num_cine && num_cine !== "null" && chain_event.sites.filter(site => site.id == num_cine).length <= 0){
          return false;
        }
        const first_date = moment(chain_event.first_date).format("YYYYMMDD");
        return first_date <= moment(next_week_start).format("YYYYMMDD");
      })
    }

    if(filteredEvents.length > 0){
      this.$createEventsCards(filteredEvents);
    }else{
      $("#wrap_current_week_movies").remove();
      if(iParam.$parent){
        iParam.$parent.remove();
      }
    }
  }

  $filterNextWeekEvents(events) {
    // console.log("dans nextweek");
    const currentDate = moment();
    let next_week_start = moment(); 
    let next_week_end = moment(); 
    let nb_day_to_next_week_start = 0;
    switch(currentDate.isoWeekday()){
      case 1:
        nb_day_to_next_week_start = 2;
        break;
      case 2:
        nb_day_to_next_week_start = 1;
        break;
      case 3:
        nb_day_to_next_week_start = 7;
        break;
      case 4:
        nb_day_to_next_week_start = 6;
        break;
      case 5:
        nb_day_to_next_week_start = 5;
        break;
      case 6:
        nb_day_to_next_week_start = 4;
        break;
      case 7:
        nb_day_to_next_week_start = 3;
        break;
      default:
        break;
    }
    
    next_week_start.add(nb_day_to_next_week_start, 'days')
    next_week_end = next_week_start.clone();

    switch(next_week_start.isoWeekday()){
      case 1:
        nb_day_to_next_week_start = 1;
        break;
      case 2:
        nb_day_to_next_week_start = 0;
        break;
      case 3:
        nb_day_to_next_week_start = 6;
        break;
      case 4:
        nb_day_to_next_week_start = 5;
        break;
      case 5:
        nb_day_to_next_week_start = 4;
        break;
      case 6:
        nb_day_to_next_week_start = 3;
        break;
      case 7:
        nb_day_to_next_week_start = 2;
        break;
      default:
        break;
    }
    next_week_end.add(nb_day_to_next_week_start, 'days')

    var filteredEvents = [];

    if(gl_config.type == "site"){
      filteredEvents = this.events.filter((event) => {
        return event.sessions.some((session) => {
          const sessionDate = moment(session.date, "YYYYMMDDHHmmss");
          return (session.booking_url && sessionDate.isBetween(next_week_start,next_week_end,null,"[]"));
        });
      });
    }else if(gl_config.type == "chain"){
      filteredEvents = this.chain_events.filter((chain_event) => {
        const first_date = moment(moment(chain_event.first_date).format("YYYYMMDD"), "YYYYMMDD");
        const last_date = moment(moment(chain_event.last_date).format("YYYYMMDD"), "YYYYMMDD");
        return ((first_date.isSameOrBefore(next_week_start)) && (last_date.isSameOrBefore(next_week_end)));
      });
    }

    if (filteredEvents.length === 0) {
      $("#wrap_next_week_movies").remove();
    }
    // console.log(filteredEvents)
    this.$createEventsCards(filteredEvents);
  }
  
  $filterShortlyMovies(iParam) {
    // console.log("$filterShortlyMovies", iParam)
    const currentDate = moment();
    let movies_list = [];
    let events = iParam && iParam.events ? iParam.events : [];
    let num_cine = iParam && iParam.num_cine ? iParam.num_cine : null;

    if(gl_config.type == "site"){
      events.forEach(movie => {
        if(movie.sessions.length > 0){
          // On regarde dans un premier temps, si le film à des séances avant le prochain mercredi
          const sessions_this_week = movie.sessions.filter((session) => {
            const session_date = moment(session.date, "YYYYMMDDHHmmss");
            if(currentDate.day() < 3){
              return (session_date.isSameOrBefore(moment().day(2)));
            }else{
              return (session_date.isSameOrBefore(moment().day(9)));
            }
          });

          if(sessions_this_week.length > 0){
            return;
          }

          const valid_sessions = movie.sessions.filter((session) => {
              const session_date = moment(session.date, "YYYYMMDDHHmmss");
              if(currentDate.day() < 3){
                return (session_date.isSameOrAfter(moment().day(2)));
              }else{
                return (session_date.isSameOrAfter(moment().day(9)));
              }
          });
          if(valid_sessions.length > 0 && movies_list.filter(m => m.id == movie.id).length <= 0){
              movies_list.push(movie);
          }
        }
      });
    }else if(gl_config.type == "chain"){
      movies_list = this.chain_events.filter((chain_event) => {
        if(num_cine && num_cine !== "null" && chain_event.sites.filter(site => site.id == num_cine).length <= 0){
          return false;
        }
        const first_date = moment(moment(chain_event.first_date).format("YYYYMMDD"), "YYYYMMDD");
        return first_date.isSameOrAfter(moment().day(10));
        // return first_date.isSameOrAfter(moment().day(3));
      });
    }   

    if (movies_list.length === 0) {
      this.$parent.remove();
      if(iParam.$parent){
        iParam.$parent.remove();
      }
    }

    this.$createEventsCards(movies_list);
  }
}
